import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "@mui/material/Tooltip";
import {checkNull} from "../utils/ReactUtils";
import {THEME} from "../config/FusionConfig";

//fa fa or bi bi icons
const Icon = React.memo(({
                             className = "",
                             icon = "",
                             size = "",
                             style = {},
                             color = "black",
                             highlightVariant = THEME,
                             tooltip,
                             onClick,
                         }) => {
    return (<>
            <Tooltip title={tooltip}>
                <i
                    className={`${icon} ${className} highlight-text-${checkNull(onClick) ? `${highlightVariant} cursor-pointer` : ''}`}
                    onClick={onClick}
                    style={{
                        fontSize: size,
                        color: color, ...style
                    }}
                />
            </Tooltip>
        </>
    )
});
Icon.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(['13px'])]),
    style: PropTypes.object
};
export default Icon;
